import React, { forwardRef } from "react";
import { ChevronDown } from "lucide-react";

const StickyButton = forwardRef(
  ({ isSticky, containerWidth, onClick, label }, ref) => {
    return (
      <div
        ref={ref}
        className={`
        flex flex-1 px-5 py-7 items-center rounded-lg justify-between 
        font-geomanistBold transition-all [&[data-state=open]>svg]:rotate-180 
        shadow-minShadow cursor-pointer
        ${
          isSticky
            ? "sticky bottom-4 left-0 right-0 max-w-[calc(100%-32px)] w-full bg-white z-50 shadow-lg"
            : "relative"
        }
      `}
        style={
          isSticky ? { maxWidth: containerWidth || "calc(100% - 32px)" } : {}
        }
        onClick={onClick}
      >
        {label}
        <div className="px-5">
          <ChevronDown className="text-blackShade -rotate-90" />
        </div>
      </div>
    );
  }
);

export default StickyButton;
